/** Navigation links shared by desktop footer and mobile menu footer */
export const FOOTER_NAV_LINKS = [
  { to: '/', label: 'Forside' },
  { to: '/institution-list', label: 'Institutionsliste' },
  { to: '/map', label: 'Institutionskort' },
  { to: '/om', label: 'Om os' },
  { to: '/privatliv', label: 'Privatliv' },
  { to: '/vilkar', label: 'Vilkår' },
];
